import axios from 'axios'
import { unwrapApiEnvelope } from '@/shared/lib/api-envelope'
import { buildApiUrl } from '@/shared/lib/api-origin'
import { clearAuthToken, getAuthToken } from '@/shared/lib/auth-token'

const api = axios.create({
  baseURL: buildApiUrl('/api/consumer'),
  // Token transport only: the consumer SPA authenticates with the
  // X-Session-Token header, never cookies (Firebase strips all but __session).
  withCredentials: false,
  // Bound every request so a stalled upload/API call fails with an error the
  // UI can surface, instead of spinning forever. File uploads override this
  // with a longer per-request timeout (see useConsumerFileUpload).
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use((config) => {
  const token = getAuthToken()
  if (token) {
    config.headers['X-Session-Token'] = token
  }
  return config
})

api.interceptors.response.use(
  (response) => unwrapApiEnvelope(response),
  (error) => {
    // Token expired or server-side revoked: drop it so the consumer session
    // query reflects logged-out state and the app returns to the magic-link
    // entry point.
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      clearAuthToken()
    }
    return Promise.reject(error)
  },
)

export default api
